import styled, { css } from 'styled-components';

interface Props {
  isCurrentDay: boolean;
  isInSelectedWeek: boolean;
  isCurrentMonth: boolean;
}

export const Container = styled.div<Props>`
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  ${({ theme, isCurrentMonth, isInSelectedWeek, isCurrentDay }) => css`
    border-radius: ${theme.borderRadius.default};

    background-color: ${isInSelectedWeek
      ? theme.colors.lightGrey.main
      : 'transparent'};

    ${!isCurrentMonth &&
    css`
      color: ${theme.colors.darkGrey.main};
    `}

    ${isCurrentDay &&
    css`
      color: #58bd88;
    `}

    ${!isInSelectedWeek &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${theme.colors.lightGrey.active};
      }
    `}
  `}
`;
